var map = {
	"./IndustrySolution/ClassicCases/360_background.png": "abfe",
	"./IndustrySolution/ClassicCases/360_icon.png": "090f",
	"./IndustrySolution/ClassicCases/Banking.png": "7102",
	"./IndustrySolution/ClassicCases/BeiFangHuaChuang.png": "21f7",
	"./IndustrySolution/ClassicCases/CHNT.png": "0ae1",
	"./IndustrySolution/ClassicCases/Canaan.png": "d08e",
	"./IndustrySolution/ClassicCases/G7.png": "e92f",
	"./IndustrySolution/ClassicCases/GODIVA.png": "e441",
	"./IndustrySolution/ClassicCases/GODIVA_background.png": "4d85",
	"./IndustrySolution/ClassicCases/GODIVA_icon.png": "a6c1",
	"./IndustrySolution/ClassicCases/Geek.png": "fa2d",
	"./IndustrySolution/ClassicCases/Giti_background.png": "4f91",
	"./IndustrySolution/ClassicCases/Giti_icon.png": "67d9",
	"./IndustrySolution/ClassicCases/H3C.png": "9877",
	"./IndustrySolution/ClassicCases/HITACHI.jpg": "11fe",
	"./IndustrySolution/ClassicCases/HITACHI.png": "4d13",
	"./IndustrySolution/ClassicCases/Hanshow.png": "fa07",
	"./IndustrySolution/ClassicCases/Innoscience.png": "fd6f",
	"./IndustrySolution/ClassicCases/KAIFA.png": "8fcc",
	"./IndustrySolution/ClassicCases/KyowaKIRIN-background.png": "783d",
	"./IndustrySolution/ClassicCases/KyowaKIRIN-icon.png": "1879",
	"./IndustrySolution/ClassicCases/LanEn_background.png": "e236",
	"./IndustrySolution/ClassicCases/LanEn_icon.png": "3cf6",
	"./IndustrySolution/ClassicCases/MAGNA_background.png": "569b",
	"./IndustrySolution/ClassicCases/MAGNA_icon.png": "0e9c",
	"./IndustrySolution/ClassicCases/NORMA-GROUP.png": "4261",
	"./IndustrySolution/ClassicCases/Ninebot.png": "2239",
	"./IndustrySolution/ClassicCases/QIANXIN.png": "3177",
	"./IndustrySolution/ClassicCases/SUMMERGATE.png": "dfd1",
	"./IndustrySolution/ClassicCases/SUMMERGATE_background.png": "210a",
	"./IndustrySolution/ClassicCases/SUMMERGATE_icon.png": "3458",
	"./IndustrySolution/ClassicCases/SUNGROW.png": "da63",
	"./IndustrySolution/ClassicCases/SUNMI.png": "8001",
	"./IndustrySolution/ClassicCases/TAIDA.jpg": "4ec6",
	"./IndustrySolution/ClassicCases/TCL.png": "5b38",
	"./IndustrySolution/ClassicCases/Trinasolar.png": "02e8",
	"./IndustrySolution/ClassicCases/VERTIV.png": "2683",
	"./IndustrySolution/ClassicCases/WEILINGTON_background.png": "c56a",
	"./IndustrySolution/ClassicCases/WEILINGTON_icon.png": "8e3b",
	"./IndustrySolution/ClassicCases/Xiaomi.jpg": "4835",
	"./IndustrySolution/ClassicCases/Xiaomi.png": "ae61",
	"./IndustrySolution/ClassicCases/disperse_icon01.jpg": "a569",
	"./IndustrySolution/ClassicCases/fmcg_icon03.png": "8dbf",
	"./IndustrySolution/ClassicCases/medical_icon01.png": "6801",
	"./IndustrySolution/ClassicCases/medical_icon02.png": "3194",
	"./IndustrySolution/ClassicCases/medical_icon03.png": "772a",
	"./IndustrySolution/MedicineAdvantages/Advantages-background.png": "d06a2",
	"./IndustrySolution/MedicineAdvantages/Advantages-icon01.png": "175b",
	"./IndustrySolution/MedicineAdvantages/Advantages-icon02.png": "f9cc",
	"./IndustrySolution/MedicineAdvantages/Advantages-icon03.png": "5b57",
	"./IndustrySolution/MedicineAdvantages/Advantages-icon04.png": "78af",
	"./IndustrySolution/automobileSolutions/automobileSolutions_bg.png": "b27f",
	"./IndustrySolution/automobileSolutions/textIcon.png": "ea12",
	"./IndustrySolution/banner/industry-banner-01.png": "ac5b",
	"./IndustrySolution/banner/industry-banner-02.png": "4f65",
	"./IndustrySolution/banner/industry-banner-03.png": "4e90",
	"./IndustrySolution/banner/industry-banner-04.png": "0ae9",
	"./IndustrySolution/banner/industry-banner-05.png": "3068",
	"./IndustrySolution/banner/industry-banner-06.png": "98d0",
	"./IndustrySolution/banner/industry-banner-crm-01.png": "26a6",
	"./IndustrySolution/banner/industry-banner-crm-02.png": "4461",
	"./IndustrySolution/banner/industry-banner-crm-03.png": "ad1d",
	"./IndustrySolution/banner/industry-banner-crm-04.png": "d496",
	"./IndustrySolution/banner/industry-banner-crm-icon1.png": "2fd2",
	"./IndustrySolution/banner/industry-banner-icon1.png": "6dab",
	"./IndustrySolution/crm/crmSemiconductor/advantage_01.png": "b1de",
	"./IndustrySolution/crm/crmSemiconductor/advantage_02.png": "051e",
	"./IndustrySolution/crm/crmSemiconductor/crm_sem_solution_bg.png": "d7a7",
	"./IndustrySolution/crm/crm_section_bg.png": "ba15",
	"./IndustrySolution/crm/crm_section_icon-1.png": "86e5",
	"./IndustrySolution/crm/elecConsume/advantage_01.png": "2871",
	"./IndustrySolution/crm/elecConsume/advantage_02.png": "3099",
	"./IndustrySolution/crm/elecConsume/advantage_03.png": "16f5",
	"./IndustrySolution/crm/elecConsume/crm_elec_solution_bg.png": "2cfa",
	"./IndustrySolution/crm/highTech/advantage_01.png": "149c",
	"./IndustrySolution/crm/highTech/advantage_02.png": "3fe1",
	"./IndustrySolution/crm/highTech/highTech_solution_bg.png": "df8d",
	"./IndustrySolution/crm/newEnergy/advantage_01.png": "1b6b",
	"./IndustrySolution/crm/newEnergy/advantage_02.png": "ba17",
	"./IndustrySolution/crm/newEnergy/advantage_03.png": "9bea",
	"./IndustrySolution/crm/newEnergy/newEnergy_solution_bg.png": "739f",
	"./IndustrySolution/crm/value_bg_img.png": "d3ce",
	"./IndustrySolution/crm/value_img.png": "9eca",
	"./IndustrySolution/customValue/bg_img01.png": "ce1b",
	"./IndustrySolution/customValue/custom_card_img1.png": "d067",
	"./IndustrySolution/customValue/custom_value_bg_img.png": "c6f4",
	"./IndustrySolution/disperse/disperse-icon-01.png": "3df8",
	"./IndustrySolution/disperse/disperse-icon-02.png": "48e1",
	"./IndustrySolution/disperse/disperse-icon-03.png": "a92a",
	"./IndustrySolution/disperse/disperse-icon-04.png": "8ac3",
	"./IndustrySolution/disperse/disperse-icon-05.png": "6975",
	"./IndustrySolution/disperse/disperse-icon-06.png": "122b",
	"./IndustrySolution/disperse/disperse-icon.png": "cab8",
	"./IndustrySolution/disperse/disperse_advantage_bg_img01.png": "a9ca",
	"./IndustrySolution/disperseSolutions/icon_solution.png": "093b",
	"./IndustrySolution/disperseSolutions/solution_sheet_bg.png": "7382",
	"./IndustrySolution/disperseSolutions/summary_item_bg1.png": "3bdf",
	"./IndustrySolution/disperseSolutions/summary_item_bg2.png": "ec90",
	"./IndustrySolution/disperseSolutions/summary_item_bg3.png": "3227",
	"./IndustrySolution/educationSolution/edu_solution_sheet_bg.png": "aa97",
	"./IndustrySolution/medicalSolutions/left-icon.png": "d3d7",
	"./IndustrySolution/medicalSolutions/right-icon.png": "ee69",
	"./IndustrySolution/medicalSolutions/solution-big.png": "869f",
	"./IndustrySolution/medicalSolutions/solution-big1.png": "b051",
	"./IndustrySolution/medicalSolutions/solution-icon01.png": "7b53",
	"./IndustrySolution/medicalSolutions/solution-icon02.png": "96d7",
	"./IndustrySolution/medicalSolutions/solution-icon03.png": "92e4",
	"./IndustrySolution/medicalSolutions/solution-icon04.png": "cbf1",
	"./IndustrySolution/medicalSolutions/solution-icon05.png": "7c62",
	"./IndustrySolution/medicalSolutions/solution-icon06.png": "b15e",
	"./IndustrySolution/medicalSolutions/solution-icon07.png": "eac0",
	"./IndustrySolution/medicalSolutions/solution-icon08.png": "d537",
	"./IndustrySolution/medicalSolutions/solution-icon09.png": "0b48",
	"./IndustrySolution/programmeAdvantage/bg01.png": "94e1",
	"./IndustrySolution/programmeAdvantage/bg02.png": "3cbc",
	"./IndustrySolution/programmeAdvantage/bg03.png": "83f6",
	"./IndustrySolution/programmeAdvantage/process-support.png": "f7db",
	"./IndustrySolution/programmeAdvantage/production-management.png": "a7ee",
	"./IndustrySolution/programmeAdvantage/quality-traceability.png": "06c0",
	"./IndustrySolution/retailFMCG/retail_advantage_bg_img01.png": "59ae",
	"./IndustrySolution/retailFMCG/retail_solution_bg_img01.png": "53e9",
	"./IndustrySolution/semiconductor/semiconductor_advantage_bg_img01.png": "3315",
	"./IndustrySolution/semiconductor/semiconductor_icon_01.png": "992c",
	"./IndustrySolution/semiconductor/semiconductor_icon_02.png": "7d8d",
	"./IndustrySolution/semiconductor/semiconductor_icon_03.png": "a527",
	"./IndustrySolution/semiconductor/semiconductor_icon_04.png": "c154",
	"./IndustrySolution/semiconductor/semiconductor_icon_05.png": "c6f9",
	"./IndustrySolution/semiconductor/semiconductor_icon_06.png": "272b",
	"./IndustrySolution/semiconductor/semiconductor_icon_07.png": "d06a",
	"./IndustrySolution/semiconductor/semiconductor_icon_yes.png": "ce2c",
	"./IndustrySolution/semiconductor/semiconductor_solution_bg_img01.png": "fa9f",
	"./ProductService/VyungCPQ/CPQ-Image.png": "b8f4",
	"./ProductService/VyungCPQ/CPQ-ability-01.png": "a71b",
	"./ProductService/VyungCPQ/CPQ-ability-02.png": "050c",
	"./ProductService/VyungCPQ/CPQ-video.jpg": "a95f",
	"./ProductService/VyungCPQ/Flexible-deployment.png": "4c37",
	"./ProductService/VyungCPQ/blueprint-background.png": "0e03",
	"./ProductService/VyungCPQ/performance-image.png": "0492",
	"./ProductService/VyungCPQ/system-integrating.png": "1f87",
	"./ProductService/VyungCPQ/universal-model.png": "d4f7",
	"./ProductService/VyungFCST/01.png": "5b56",
	"./ProductService/VyungFCST/02.png": "2b1b3",
	"./ProductService/VyungFCST/03.png": "b6f2",
	"./ProductService/VyungFCST/04.png": "3674",
	"./ProductService/VyungFCST/05.png": "2cb8",
	"./ProductService/VyungFCST/06.png": "4199",
	"./ProductService/VyungFCST/FCST-Image.png": "0d09",
	"./ProductService/VyungFCST/FCST-ability-01.png": "fb18",
	"./ProductService/VyungFCST/FCST-ability-02.png": "04c8",
	"./ProductService/VyungFCST/FCST-ability-03.png": "8e15",
	"./ProductService/VyungFCST/FCST-ability-04.png": "fc18",
	"./ProductService/VyungFCST/FCST_icon01.png": "66a6",
	"./ProductService/VyungFCST/FCST_icon02.png": "2d62",
	"./ProductService/VyungFCST/brand-icon.png": "c893",
	"./ProductService/VyungFCST/business-blueprint_bg.png": "67ff",
	"./ProductService/VyungFCST/business_sheet_bg.png": "005a",
	"./ProductService/VyungFCST/fcst_video_thumb.jpg": "596f",
	"./ProductService/VyungFCST/play-icon.png": "0d72",
	"./ProductService/VyungFCST/product-superiority.png": "02c8",
	"./ProductService/VyungFCST/summarize-background.png": "4872",
	"./ProductService/VyungLTC/LTC-Image.png": "6a29",
	"./ProductService/VyungLTC/LTC-ability-01.png": "b0ce",
	"./ProductService/VyungLTC/LTC-ability-02.png": "8f5f",
	"./ProductService/VyungLTC/LTC-ability-03.png": "3f4a",
	"./ProductService/VyungLTC/LTC-ability-04.png": "0f6c",
	"./ProductService/VyungLTC/LTC-ability-05.png": "c442",
	"./ProductService/VyungLTC/LTC-ability-06.png": "41ed",
	"./ProductService/VyungLTC/LTC-ability-07.png": "41bf",
	"./ProductService/VyungLTC/LTC-ability-08.png": "6450",
	"./ProductService/VyungLTC/LTC_icon01.png": "c89e",
	"./ProductService/VyungLTC/LTC_icon02.png": "59b1",
	"./ProductService/VyungLTC/LTC_icon03.png": "b4f4",
	"./ProductService/VyungLTC/LTC_icon04.png": "6f65",
	"./ProductService/VyungLTC/blueprint-background.png": "e1e3",
	"./ProductService/VyungLTC/ltc_tumb.jpg": "1565",
	"./ProductService/VyungLoyalty/Loyalty-Image.png": "412f",
	"./ProductService/VyungLoyalty/Loyalty-ability-01.png": "3082",
	"./ProductService/VyungLoyalty/Loyalty-ability-02.png": "ac6c",
	"./ProductService/VyungLoyalty/Loyalty-ability-03.png": "28a7",
	"./ProductService/VyungLoyalty/Loyalty-ability-04.png": "03eb",
	"./ProductService/VyungLoyalty/Loyalty-ability-05.png": "0d7c",
	"./ProductService/VyungLoyalty/Loyalty_icon01.png": "8548",
	"./ProductService/VyungLoyalty/Loyalty_icon02.png": "c197",
	"./ProductService/VyungLoyalty/Loyalty_icon03.png": "37e5",
	"./ProductService/VyungLoyalty/Loyalty_icon04.png": "5e55",
	"./ProductService/VyungLoyalty/blueprint-background.png": "57dd",
	"./ProductService/VyungLoyalty/loyalty_tumb.png": "3a50",
	"./ProductService/VyungService/Service-Image.png": "f3e1",
	"./ProductService/VyungService/Service-ability-01.png": "09d5",
	"./ProductService/VyungService/Service-ability-02.png": "f86b",
	"./ProductService/VyungService/Service-ability-03.png": "e537",
	"./ProductService/VyungService/Service-ability-04.png": "a888",
	"./ProductService/VyungService/Service-ability-05.png": "0ee0",
	"./ProductService/VyungService/Service_icon01.png": "e3cd",
	"./ProductService/VyungService/Service_icon02.png": "ebf6",
	"./ProductService/VyungService/Service_icon03.png": "7ffd",
	"./ProductService/VyungService/Service_icon04.png": "b522",
	"./ProductService/VyungService/blueprint-background.png": "c34f",
	"./ProductService/VyungService/service_tumb.jpg": "d762",
	"./ProductService/VyungWorkflow/Workflow-ability-01.png": "0884",
	"./ProductService/VyungWorkflow/Workflow-ability-02.png": "e400",
	"./ProductService/VyungWorkflow/Workflow-ability-03.png": "d4ef",
	"./ProductService/VyungWorkflow/Workflow-ability-04.png": "a22b",
	"./ProductService/VyungWorkflow/Workflow-ability-05.png": "d1eb",
	"./ProductService/VyungWorkflow/Workflow-ability-06.png": "2e11",
	"./ProductService/VyungWorkflow/Workflow_Image.png": "08e7",
	"./ProductService/VyungWorkflow/Workflow_icon01.png": "5844",
	"./ProductService/VyungWorkflow/Workflow_icon02.png": "23bf",
	"./ProductService/VyungWorkflow/Workflow_icon03.png": "67c8",
	"./ProductService/VyungWorkflow/Workflow_icon04.png": "2732",
	"./ProductService/VyungWorkflow/Workflow_icon05.png": "3532",
	"./ProductService/VyungWorkflow/Workflow_icon06.png": "871e",
	"./ProductService/VyungWorkflow/workflow_1.jpg": "d2e5",
	"./ProductService/VyungWorkflow/workflow_2.jpg": "0f28",
	"./ProductService/VyungWorkflow/workflow_3.jpg": "f69c",
	"./ProductService/VyungWorkflow/workflow_4.jpg": "db25",
	"./ProductService/VyungWorkflow/workflow_5.jpg": "4f90",
	"./ProductService/VyungWorkflow/workflow_6.jpg": "bfb3",
	"./ProductService/VyungWorkflow/workflow_7.jpg": "6ab4",
	"./ProductService/VyungWorkflow/workflow_8.jpg": "eb71",
	"./ProductService/VyungWorkflow/workflow_tumb.png": "90a2",
	"./ProductService/common/01.png": "d7b1",
	"./ProductService/common/02.png": "d7eb",
	"./ProductService/common/03.png": "d167",
	"./ProductService/common/04.png": "2ba1",
	"./ProductService/common/05.png": "a2e0",
	"./ProductService/common/06.png": "2f9e",
	"./ProductService/common/A0SMITH-icon.png": "a549",
	"./ProductService/common/ADORITZ-icon.png": "f608",
	"./ProductService/common/AMERSPORTS-icon.png": "1d68",
	"./ProductService/common/ARCTERYX-icon.png": "2452",
	"./ProductService/common/ASTRONERGY-icon.png": "6d08",
	"./ProductService/common/AUX-icon.png": "76a2",
	"./ProductService/common/CHICMAX-icon.jpg": "f1e0",
	"./ProductService/common/CNFN-icon.png": "c188",
	"./ProductService/common/CenturySunshine-icon.png": "3bb9",
	"./ProductService/common/Chambroad-icon.png": "9736",
	"./ProductService/common/Chianxin-icon.png": "9fcf",
	"./ProductService/common/DW-icon.png": "1fc5",
	"./ProductService/common/Delta-icon.png": "8f66",
	"./ProductService/common/GRGBanking-icon.png": "3607",
	"./ProductService/common/H3C-icon.png": "9809",
	"./ProductService/common/HAMAMATSU-icon.png": "1ee8",
	"./ProductService/common/HERBORIST-icon.png": "56b1",
	"./ProductService/common/HITACHI-background.png": "cc6f",
	"./ProductService/common/HITACHI-icon.png": "1183",
	"./ProductService/common/HITACHI.jpg": "edb6",
	"./ProductService/common/Innoscience-icon.png": "23d6",
	"./ProductService/common/JINMAO-icon.png": "0edf",
	"./ProductService/common/JOHN-icon.png": "96c6",
	"./ProductService/common/Jahwa-icon.png": "15ca",
	"./ProductService/common/JinJiang-icon.png": "54af",
	"./ProductService/common/JinTianGroup-icon.png": "bc91",
	"./ProductService/common/KAIFA-icon.png": "3f0c",
	"./ProductService/common/LAOPU-icon.jpg": "28dc",
	"./ProductService/common/LAOPU-icon.png": "b464",
	"./ProductService/common/Lenovo-icon.png": "7095",
	"./ProductService/common/Leysen-icon.png": "9031",
	"./ProductService/common/MAOGEPING-icon.png": "bb15",
	"./ProductService/common/MOCo-icon.png": "88a8",
	"./ProductService/common/PRINX-icon.png": "3437",
	"./ProductService/common/SALOMON-icon.jpg": "0319",
	"./ProductService/common/SUUNTO-icon.png": "a9dc",
	"./ProductService/common/ShengHong-icon.png": "0214",
	"./ProductService/common/SunGrow-icon.png": "f346",
	"./ProductService/common/TAIDA.jpg": "dc10",
	"./ProductService/common/TCL-icon.png": "90c3",
	"./ProductService/common/ThomasCook-icon.png": "44da",
	"./ProductService/common/TongDing-icon.png": "0cc4",
	"./ProductService/common/VERTIV-icon.png": "814a",
	"./ProductService/common/WEICHAI-icon.png": "7e66",
	"./ProductService/common/Wi-icon.png": "afc3",
	"./ProductService/common/YTO-background.png": "3dfa",
	"./ProductService/common/YTO-icon.png": "68b0",
	"./ProductService/common/business-blueprint.png": "1ab8",
	"./ProductService/common/gf-icon.png": "2414",
	"./ProductService/common/lovebaby-icon.png": "ed56",
	"./ProductService/common/ninebot-icon.png": "d71a",
	"./ProductService/common/phone_bg.png": "f4ca",
	"./ProductService/common/play-icon.png": "46b1",
	"./ProductService/common/product-superiority.png": "6a14",
	"./ProductService/common/sacredsun-icon.png": "11f3",
	"./ProductService/common/summarize-background.png": "070e",
	"./ProductService/common/unknow-icon.png": "bb01",
	"./ProductService/common/zhongtong-background.png": "31e3",
	"./ProductService/common/zhongtong-icon.png": "4532",
	"./about/about-1.png": "c543",
	"./about/about-2.png": "b099",
	"./about/about-3.png": "4093",
	"./about/about-4.png": "0edf1",
	"./about/about-5.png": "eade",
	"./about/about-6.png": "1c99",
	"./about/about-logo.png": "db2b",
	"./about/contact-image.jpg": "66d6",
	"./aboutUs/about-us-icon.png": "671f",
	"./aboutUs/aboutUs-header-img01.png": "8d40",
	"./aboutUs/aboutUs-header-img02.png": "bf35",
	"./aboutUs/aboutUs-header-img02_en.png": "24ff",
	"./aboutUs/aboutUs-header-img02_ja.png": "c57c",
	"./aboutUs/aboutUs-map.png": "d058",
	"./aboutUs/aboutUs_time_line_img.png": "c50c",
	"./aboutUs/about_us_banner_mobile.png": "db56",
	"./aboutUs/about_us_banner_pc.png": "10a7",
	"./aboutUs/address/changsha_center.jpg": "5987",
	"./aboutUs/address/changzhou_center.jpg": "82ce",
	"./aboutUs/address/indonesia_center.jpg": "87e4",
	"./aboutUs/address/shanghai.jpg": "c293",
	"./aboutUs/address/wuhan_center.jpg": "cc23",
	"./aboutUs/address/xian_center.jpg": "8545",
	"./aboutUs/address/zhengzhou_center.jpg": "88a2",
	"./aboutUs/blue_star.png": "63a2",
	"./aboutUs/changsha01.png": "282e",
	"./aboutUs/changsha02.png": "3dc6",
	"./aboutUs/changzhou01.png": "4d99",
	"./aboutUs/changzhou02.png": "8004",
	"./aboutUs/china_map.png": "1f35",
	"./aboutUs/circle1.png": "7455",
	"./aboutUs/circle2.png": "bf9c",
	"./aboutUs/company_image.png": "bc2d",
	"./aboutUs/company_map.png": "5903",
	"./aboutUs/gray_location.png": "dec7",
	"./aboutUs/introduction-01.png": "3995",
	"./aboutUs/map.png": "d0a1",
	"./aboutUs/product.png": "7161",
	"./aboutUs/shanghai.png": "2464",
	"./aboutUs/shanghai02.png": "a4f1",
	"./aboutUs/time_line_circle.png": "68ee",
	"./aboutUs/time_line_img01.png": "f74c",
	"./aboutUs/time_line_img02.png": "0e4f",
	"./aboutUs/time_line_img03.png": "a4bf",
	"./aboutUs/time_line_img04.png": "fcb0",
	"./aboutUs/time_line_img05.png": "4463",
	"./aboutUs/time_line_img06.png": "5b46",
	"./aboutUs/time_line_img07.png": "a963",
	"./aboutUs/time_line_img08.png": "4ca4",
	"./aboutUs/time_line_img09.png": "6650",
	"./aboutUs/time_line_img10.png": "1f77",
	"./aboutUs/time_line_img11.png": "f45e",
	"./aboutUs/time_line_img12.png": "2d89",
	"./aboutUs/time_line_img13.png": "5112",
	"./aboutUs/time_line_img14.png": "0dc7",
	"./aboutUs/time_line_img15.png": "7a49",
	"./aboutUs/time_line_img16.png": "bf0d",
	"./aboutUs/time_line_img17.png": "c018",
	"./aboutUs/time_line_img2024.png": "7183",
	"./aboutUs/title_image.png": "f2b6",
	"./aboutUs/wuhan01.png": "71c8",
	"./aboutUs/wuhan02.png": "225f",
	"./aboutUs/xian01.png": "1d0e",
	"./aboutUs/xian02.png": "a510",
	"./aboutUs/yellow_location.png": "66a5",
	"./aboutUs/zhengzhou01.png": "5a22",
	"./aboutUs/zhengzhou02.png": "92f0",
	"./banner/banenr-image-02.png": "c5b0a",
	"./banner/home_banner.png": "9fae",
	"./banner/white-shape.svg": "d514",
	"./brand/brand-1.png": "2e14",
	"./brand/brand-10.png": "7eb7",
	"./brand/brand-11.png": "44a7",
	"./brand/brand-12.png": "1ae4",
	"./brand/brand-13.png": "cf55",
	"./brand/brand-14.png": "e031",
	"./brand/brand-15.png": "0493",
	"./brand/brand-16.png": "db1a",
	"./brand/brand-17.png": "6754",
	"./brand/brand-18.png": "c3ac",
	"./brand/brand-19.png": "8d92",
	"./brand/brand-2.png": "8816",
	"./brand/brand-20.png": "6b9c",
	"./brand/brand-21.png": "a59a",
	"./brand/brand-22.png": "a38f",
	"./brand/brand-23.png": "ffa1",
	"./brand/brand-24.png": "0d3a",
	"./brand/brand-25.png": "c50c1",
	"./brand/brand-26.png": "48a9",
	"./brand/brand-27.png": "8c1f",
	"./brand/brand-28.png": "2e80",
	"./brand/brand-3.png": "6170",
	"./brand/brand-4.png": "8271",
	"./brand/brand-5.png": "7ed0",
	"./brand/brand-6.png": "7357",
	"./brand/brand-7.png": "6b74",
	"./brand/brand-8.png": "85ac",
	"./brand/brand-9.png": "755f",
	"./customerCase/brand-cases1.png": "570f",
	"./customerCase/brand-cases10.png": "038b",
	"./customerCase/brand-cases11.png": "77e7",
	"./customerCase/brand-cases12.png": "58f9",
	"./customerCase/brand-cases13.png": "7f6a",
	"./customerCase/brand-cases14.png": "731f",
	"./customerCase/brand-cases15.png": "34aa",
	"./customerCase/brand-cases16.png": "57ea",
	"./customerCase/brand-cases17.png": "b1cf",
	"./customerCase/brand-cases18.png": "baf7",
	"./customerCase/brand-cases19.png": "cb4e",
	"./customerCase/brand-cases2.png": "3dfd",
	"./customerCase/brand-cases20.png": "7be1",
	"./customerCase/brand-cases21.png": "d10b",
	"./customerCase/brand-cases22.png": "db38",
	"./customerCase/brand-cases23.png": "9bc9",
	"./customerCase/brand-cases24.png": "685e",
	"./customerCase/brand-cases25.png": "533c",
	"./customerCase/brand-cases26.png": "a809",
	"./customerCase/brand-cases27.png": "5a8a",
	"./customerCase/brand-cases28.png": "1312",
	"./customerCase/brand-cases3.png": "dc68",
	"./customerCase/brand-cases4.png": "7cfe",
	"./customerCase/brand-cases5.png": "79ff",
	"./customerCase/brand-cases6.png": "eb34",
	"./customerCase/brand-cases7.png": "1d18",
	"./customerCase/brand-cases8.png": "3756",
	"./customerCase/brand-cases9.png": "e197",
	"./customerCase/cases01-bg.jpg": "b553",
	"./customerCase/cases01-bg.png": "cb76",
	"./customerCase/cases01.png": "31a0",
	"./customerCase/cases02-bg.jpg": "5b7c",
	"./customerCase/cases02-bg.png": "9df5",
	"./customerCase/cases02.png": "8c65",
	"./customerCase/cases03-bg.png": "bc3a",
	"./customerCase/cases03.png": "30da",
	"./customerCase/cases04-bg.png": "5a5a",
	"./customerCase/cases04.png": "7da5",
	"./customerCase/cases05-bg.jpg": "4a6d",
	"./customerCase/cases05.jpg": "9beb",
	"./customerCase/circle.png": "a404",
	"./customerCase/customerCase.png": "87fb",
	"./customerCase/customerCase1.jpg": "f980",
	"./customerCase/jahwa.png": "0361",
	"./footer/select_icon.png": "03eb2",
	"./globalHover/icon_up.png": "51e7",
	"./globalHover/icon_up_white.png": "ca9e",
	"./globalHover/img_01_earphone.png": "2c65",
	"./globalHover/img_02_phone.png": "ad95",
	"./globalHover/img_03_form.png": "48be",
	"./globalHover/img_04_top.png": "5cc6",
	"./goOverseas/capacity-01.png": "c116",
	"./goOverseas/capacity-02.png": "3643",
	"./goOverseas/capacity-03.png": "b641",
	"./goOverseas/capacity-04.png": "2c87",
	"./goOverseas/challenge-background-img.png": "3e9e",
	"./goOverseas/choose-01.png": "aeeb",
	"./goOverseas/choose-02.png": "f9c4c",
	"./goOverseas/choose-03.png": "e15b",
	"./goOverseas/choose-04.png": "d4a9",
	"./goOverseas/choose-background-img.png": "d5ef",
	"./goOverseas/choose-img.png": "e30f",
	"./goOverseas/header-background-img.png": "4735",
	"./goOverseas/serve-01.png": "2b1b",
	"./goOverseas/serve-02.png": "d020",
	"./goOverseas/serve-background-01.png": "22f6",
	"./goOverseas/serve-background-02.png": "71d5",
	"./goOverseas/serve-background-03.png": "280e",
	"./goOverseas/serve-country-01.png": "ceb3",
	"./goOverseas/serve-country-02.png": "a797",
	"./goOverseas/serve-country-03.png": "b9fe",
	"./goOverseas/serve-country-04.png": "39f9",
	"./goOverseas/serve-country-05.png": "01d9",
	"./goOverseas/serve-country-06.png": "0d13",
	"./goOverseas/serve-country-07.png": "24a2",
	"./goOverseas/serve-icon.png": "f3ba",
	"./goOverseas/summarize-01.png": "bf2f",
	"./goOverseas/summarize-02.png": "f8c4",
	"./goOverseas/summarize-03.png": "9902",
	"./goOverseas/summarize-04.png": "eb8a",
	"./header/cn.svg": "bbc4",
	"./header/icon_telephone.png": "62f8",
	"./header/jp.svg": "9ffe",
	"./header/phone_bg_bar.png": "bea6",
	"./header/phone_bg_bar.svg": "f8ac",
	"./header/usa.svg": "3225",
	"./home/arr_dark.png": "3aa2",
	"./home/arr_light.png": "e39a",
	"./home/case-bg.png": "51b6",
	"./home/count-01.png": "698b",
	"./home/count-02.png": "ea71",
	"./home/count-03.png": "ddc9",
	"./home/count-04.png": "6b6e",
	"./home/crm01.jpg": "d0e6",
	"./home/crm02.jpg": "e37c",
	"./home/crm03.jpg": "6e05",
	"./home/crm04.jpg": "f74d",
	"./home/erp01.jpg": "b31b",
	"./home/erp02.jpg": "4c78",
	"./home/erp03.jpg": "32f4",
	"./home/erp04.jpg": "f5f4",
	"./home/erp05.jpg": "4870",
	"./home/erp06.jpg": "2339",
	"./home/home_cpq.png": "9421",
	"./home/home_fcst.png": "c7c0",
	"./home/home_loyalty.png": "4131",
	"./home/home_ltc.png": "9df3",
	"./home/home_service.png": "b3db",
	"./home/home_workflow.png": "a932",
	"./home/icon-win.png": "18f8",
	"./home/icon_win_en.png": "58c6",
	"./home/product-bg-1.png": "d56f",
	"./home/product-bg-2.png": "73f9",
	"./home/product-icon-1.png": "d803",
	"./home/product-icon-2.png": "9180",
	"./home/product-icon-3.png": "2ec4",
	"./home/qr_code.png": "2b9f",
	"./home/qr_gzh.png": "c013",
	"./home/qr_sph.png": "0cff",
	"./icons/beian.png": "b3e1",
	"./icons/cert-beian.gif": "228e",
	"./icons/intro_thumb.jpeg": "b58d",
	"./icons/play.png": "070a",
	"./icons/sun-01.svg": "d9a1",
	"./icons/vector.svg": "ffe2",
	"./logo/favicon.png": "6d55",
	"./logo/logo-2x.png": "97d3",
	"./logo/logo-colorfull-2x.png": "0b3d",
	"./logo/logo-colorfull.png": "06b7",
	"./logo/logo-dark.png": "6996",
	"./logo/logo.png": "a4ef",
	"./logo/sflogo-dark.png": "10c6",
	"./news/news-list-top-bg.png": "7e22",
	"./news/news_center.jpg": "3eb6",
	"./news/news_date.png": "2b92",
	"./news/right-row.svg": "b52d",
	"./news/turnpage-left-prev.svg": "3898",
	"./news/turnpage-right-next.svg": "5c12",
	"./portfolio/portfolio-01.jpg": "4eac",
	"./portfolio/portfolio-02.jpg": "605d3",
	"./portfolio/portfolio-03.jpg": "0edc",
	"./portfolio/portfolio-04.jpg": "0513",
	"./portfolio/portfolio-05 - Copy.jpg": "f83c",
	"./portfolio/portfolio-05.jpg": "c827",
	"./portfolio/portfolio-06 - Copy.jpg": "ce5b",
	"./portfolio/portfolio-06.jpg": "3150",
	"./portfolio/portfolio-07.jpg": "b61a",
	"./portfolio/portfolio-08.jpg": "08f8",
	"./service/New folder/New folder/service-01.jpg": "a148",
	"./service/New folder/New folder/service-02.jpg": "07bb",
	"./service/New folder/New folder/service-03.jpg": "e60d",
	"./service/New folder/New folder/service-04.jpg": "d970",
	"./service/New folder/New folder/service-05.jpg": "624a",
	"./service/New folder/New folder/service-06.jpg": "1053",
	"./service/New folder/service-01.jpg": "03ed",
	"./service/New folder/service-02.jpg": "77d8",
	"./service/New folder/service-03.jpg": "b761",
	"./service/New folder/service-04.jpg": "03c3",
	"./service/New folder/service-05.jpg": "2a15",
	"./service/New folder/service-06.jpg": "d895",
	"./service/dashed-line.svg": "bedf",
	"./service/gallery-image-01.png": "89cd",
	"./service/gallery-image-02.png": "b8be",
	"./service/gallery-image-03.png": "c422",
	"./service/icon-01.png": "0a35",
	"./service/icon-02.png": "7a74",
	"./service/icon-03 - Copy.png": "368e",
	"./service/icon-03---Copy---Copy.png": "6db0",
	"./service/icon-03---Copy.png": "79be",
	"./service/icon-03.png": "ee85",
	"./service/icon-04.png": "079c",
	"./service/service-01.jpg": "19bd",
	"./service/service-02.jpg": "e545",
	"./service/service-03.jpg": "f749",
	"./service/service-04.jpg": "7321",
	"./service/service-05.jpg": "f1ba",
	"./service/service-06.jpg": "072f",
	"./serviceAbility/App_icon11_position.png": "e0a7",
	"./serviceAbility/App_icon12_calendar.png": "1091",
	"./serviceAbility/App_icon13_stop.png": "eaf4",
	"./serviceAbility/App_icon14_record.png": "ef30",
	"./serviceAbility/App_icon15_task.png": "3f1e",
	"./serviceAbility/App_icon16_user.png": "fa2b",
	"./serviceAbility/App_icon17_visit.png": "7f9e",
	"./serviceAbility/CRM_swiperTab_bg.png": "0094",
	"./serviceAbility/CRM_swiperTab_img1.png": "fda9",
	"./serviceAbility/CRM_swiperTab_img2.png": "ab16",
	"./serviceAbility/CRM_swiperTab_img3.png": "82e4",
	"./serviceAbility/CRM_swiperTab_img4.png": "58e2",
	"./serviceAbility/ERP_swiperTab_bg1.png": "e2ab",
	"./serviceAbility/ERP_swiperTab_bg2.png": "3662",
	"./serviceAbility/ERP_swiperTab_bg3.png": "6f59",
	"./serviceAbility/ERP_swiperTab_bg4.png": "b89c",
	"./serviceAbility/ERP_swiperTab_bg5.png": "66af",
	"./serviceAbility/ERP_swiperTab_bg6.png": "d441",
	"./serviceAbility/SFA_icon10_assistant.png": "7fa4",
	"./serviceAbility/SFA_icon1_date.png": "72ba",
	"./serviceAbility/SFA_icon2_customer.png": "3d7b",
	"./serviceAbility/SFA_icon3_opportunity.png": "5c08",
	"./serviceAbility/SFA_icon4_order.png": "d342",
	"./serviceAbility/SFA_icon5_product.png": "6cc9",
	"./serviceAbility/SFA_icon6_statistics.png": "0ba8",
	"./serviceAbility/SFA_icon7_resource.png": "1487",
	"./serviceAbility/SFA_icon8_followUp.png": "56c3",
	"./serviceAbility/SFA_icon9_email.png": "e7db",
	"./serviceAbility/erp_tab01_img_l.png": "b203",
	"./serviceAbility/erp_tab01_img_r.png": "9089",
	"./serviceAbility/erp_tab02_img_r.png": "775e",
	"./serviceAbility/erp_tab03_img_l.jpg": "b873",
	"./serviceAbility/erp_tab03_img_l.png": "f6fc",
	"./serviceAbility/erp_tab03_img_r.png": "5d53",
	"./serviceAbility/img_phone1_SFA.png": "01af",
	"./serviceAbility/img_phone2_SFA.png": "92d0",
	"./serviceAbility/img_phone3_SFA.png": "a1f6",
	"./serviceAbility/img_phone4_APP.png": "4ea1",
	"./serviceAbility/img_phone5_APP.png": "39c9",
	"./serviceAbility/swiperTextIcon.png": "2ae9",
	"./serviceAbility/time_line_circle.png": "ce27",
	"./serviceAbility/time_line_img1.png": "613c",
	"./serviceAbility/time_line_img2.png": "e924",
	"./singleHome/about_us1.png": "657e",
	"./singleHome/about_us2.png": "59df",
	"./singleHome/about_us3.png": "8b21",
	"./singleHome/about_us4.png": "5065",
	"./singleHome/about_us5.png": "9866",
	"./singleHome/about_us_bg.png": "ca94",
	"./singleHome/cases_bg.png": "77a4",
	"./singleHome/crm/crm_case1.png": "846a",
	"./singleHome/crm/crm_case10.png": "9fad",
	"./singleHome/crm/crm_case11.png": "8ebe",
	"./singleHome/crm/crm_case2.png": "3d73",
	"./singleHome/crm/crm_case3.png": "fa8c",
	"./singleHome/crm/crm_case4.png": "e10c",
	"./singleHome/crm/crm_case5.png": "370d",
	"./singleHome/crm/crm_case6.png": "ef4e",
	"./singleHome/crm/crm_case7.png": "d649",
	"./singleHome/crm/crm_case8.png": "b221",
	"./singleHome/crm/crm_case9.png": "260f",
	"./singleHome/crm_sales1.png": "8d42",
	"./singleHome/crm_sales2.png": "7f7c",
	"./singleHome/crm_sales3.png": "8ed0",
	"./singleHome/crm_sales4.png": "cbbd",
	"./singleHome/crm_sales5.png": "bfed",
	"./singleHome/dynamics-365.png": "93d4",
	"./singleHome/erp/erp_case1.png": "6426",
	"./singleHome/erp/erp_case10.png": "44cd",
	"./singleHome/erp/erp_case2.png": "765e",
	"./singleHome/erp/erp_case3.png": "9e41",
	"./singleHome/erp/erp_case4.png": "231f",
	"./singleHome/erp/erp_case5.png": "33cf",
	"./singleHome/erp/erp_case6.png": "4798",
	"./singleHome/erp/erp_case7.png": "39be",
	"./singleHome/erp/erp_case8.jpg": "6e89",
	"./singleHome/erp/erp_case9.png": "e05e",
	"./singleHome/erp_service1.png": "b374",
	"./singleHome/erp_service2.png": "5205",
	"./singleHome/erp_service3.png": "deb6",
	"./singleHome/pp_service1.png": "f97d",
	"./singleHome/pp_service2.png": "209a",
	"./singleHome/pp_service3.png": "a376",
	"./singleHome/pp_service4.png": "73b1",
	"./singleHome/pp_service5.png": "0cdb",
	"./singleHome/single_home_banner.png": "1c6e",
	"./singleHome/slide_arr.png": "b45d",
	"./slick-arrow-left-small.png": "a282",
	"./slick-arrow-right-small.png": "a379",
	"./split/split-01.jpg": "4739",
	"./split/split-02.jpg": "7ecc",
	"./split/split-03.jpg": "1add",
	"./split/split-04.jpg": "5805",
	"./tab/tabs-01.jpg": "6a78",
	"./tab/tabs-02.jpg": "9ff7",
	"./tab/tabs-03.jpg": "9f4e",
	"./tab/tabs-04.jpg": "bc96",
	"./tab/tabs-05.jpg": "4bff",
	"./testimonial/testimonial-01.jpg": "e352",
	"./testimonial/testimonial-02.jpg": "32f1",
	"./testimonial/testimonial-03.jpg": "eb91",
	"./testimonial/testimonial-dark-01 - Copy - Copy.jpg": "3d0a",
	"./testimonial/testimonial-dark-01.jpg": "43b2",
	"./testimonial/testimonial-dark-02.jpg": "d41f",
	"./testimonial/testimonial-dark-03.jpg": "9e69",
	"./timeline/2015/15-1.png": "1365",
	"./timeline/2016/16-1.png": "ebf5",
	"./timeline/2016/16-2.png": "888c",
	"./timeline/2017/17-1.png": "ce17",
	"./timeline/2017/17-2.png": "3b21",
	"./timeline/2018/18-1.png": "b782",
	"./timeline/2018/18-2.png": "0f32",
	"./timeline/2018/18-3.png": "0bdd",
	"./timeline/2018/18-4.png": "02e1",
	"./timeline/2018/18-5.png": "8cb5",
	"./timeline/2019/19-1.png": "76f5",
	"./timeline/2019/19-2.png": "32c8",
	"./timeline/2019/19-3.png": "2433",
	"./timeline/2019/19-4.png": "8be6",
	"./timeline/2020/20-1.png": "eda2",
	"./timeline/2020/20-2.png": "8121",
	"./timeline/2020/20-3.png": "3931",
	"./timeline/2020/20-4.png": "bcc3",
	"./timeline/2020/20-5.png": "8f9a",
	"./timeline/2021/21-1.png": "ec93",
	"./timeline/2021/21-2.png": "568b",
	"./timeline/2022/22-1.png": "20cf",
	"./timeline/2022/22-2.png": "0df6",
	"./timeline/2022/22-3.png": "b5b9",
	"./timeline/2022/22-4.png": "5136",
	"./timeline/2023/23-1.png": "6a7d",
	"./timeline/2023/23-2.png": "11ce",
	"./timeline/2023/23-3.png": "a7b5",
	"./timeline/2023/23-4.png": "82d5",
	"./timeline/2023/23-5.png": "a5bf",
	"./timeline/2023/23-6.png": "3dc0",
	"./timeline/2024/24-1.png": "1504",
	"./timeline/2024/24-2.png": "85d1",
	"./timeline/2024/24-3.png": "1c9c",
	"./timeline/2024/24-4.png": "8161",
	"./timeline/2024/24-5.png": "49db",
	"./timeline/2024/24-6.png": "0cdd",
	"./timeline/2024/24-7.png": "638f",
	"./timeline/arr_left.png": "c5b0",
	"./whyChooseUs/choose-01.png": "8d07",
	"./whyChooseUs/choose-02.png": "88d4",
	"./whyChooseUs/choose-03.png": "245f",
	"./whyChooseUs/choose-04.png": "3466",
	"./whyChooseUs/choose-background-img.png": "39d0",
	"./whyChooseUs/choose-img.png": "f4d2",
	"./whyChooseUs/choose-img_en.png": "ffd5",
	"./whyChooseUs/choose-img_ja.png": "a15e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";